import _ from "lodash";
import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

const VisualizationsCollection = new Mongo.Collection("Visualizations", {
    connection: null
});

export class Visualization extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlVisualization = `${publicSettings.aws.baseUrls.dataTimeseries}/visualization`;

    constructor() {
        super(VisualizationsCollection);
    }

    /**
     *
     * @param {Boolean} true caso tenha populado
     */
    async populate(selector, options = {}) {
        // console.time(`${this.moduleName}.find.${JSON.stringify(selector)}`);

        const response = await this.getByAccountingIdSources({
            accountingId: selector.accountingId,
            sources: selector.sources
        });
        this.deleteMany(selector);
        const hasResponse = _.get(response, "length");
        if (hasResponse) this.createMany(response);
        // console.timeEnd(`${this.moduleName}.find.${JSON.stringify(selector)}`);
        return hasResponse ? true : false;
    }

    async setGoals({ accountingId, companyId, source }) {
        await this.HttpAdapter.call(`${this.baseUrlVisualization}/set-goals`, {
            accountingId,
            companyId,
            source
        });
    }

    async getByAccountingIdSources({ accountingId, sources }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlVisualization}/get-by-accountingid-sources`,
                {
                    accountingId,
                    sources: [].concat(sources)
                }
            );

            return response.list || [];
        } catch (error) {
            throw new Error(error.message);
        }
    }

    /**
     * @public
     *  cria a visualização no banco de dados
     * @param {Object} selector
     */
    async insertOne(visualization) {
        try {
            const response = await this.save(visualization);

            const visualizationCreated = {
                _id: response[0],
                createdAt: new Date().getTime(),
                ...visualization
            };

            this.create(visualizationCreated);

            return visualizationCreated;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    async remove(visualizationId) {
        if (!visualizationId) return;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlVisualization}/remove-by-id`,
                {
                    visualizationId
                }
            );
            this.delete(visualizationId);
            return true;
        } catch (error) {
            return false;
        }
    }

    async updateOne(_id, visualization) {
        if (!_id) return false;

        if (!visualization) return false;

        const response = await this.save({
            _id,
            ...visualization
        });

        this.modify({ _id: { $eq: _id } }, { ...visualization });

        return response;
    }

    async save(visualizations) {
        try {
            if (!visualizations) return false;

            const response = await this.HttpAdapter.call(
                `${this.baseUrlVisualization}/save`,
                {
                    visualizations: [].concat(visualizations)
                }
            );

            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    }

    parseDashboardVisualization({ visualizationId, companyData } = {}) {
        let visId = visualizationId;

        if (_.isObject(visualizationId)) {
            visId = visualizationId.pro;
        }

        return visId;
    }

    getDashboardsAndChildrenVisualizations(dashboards) {
        const allVisualizations = [];

        for (let index = 0; index < dashboards.length; index++) {
            const dashboard = dashboards[index];
            const indicator = {
                _id: dashboard._id,
                name: dashboard.name,
                description: dashboard.description,
                notifications: 0,
                position: dashboard.position,
                childrens: [],
                sources: dashboard.sources,
                referenceId: dashboard.referenceId,
                metadata: dashboard.metadata,
                hideCollapse:
                    dashboard._id === "balanceidTHahMb3M4F6" ? true : false
            };
            let visualizations = [];

            for (
                let sectionIndex = 0;
                sectionIndex < dashboard.sections.length;
                sectionIndex++
            ) {
                const section = dashboard.sections[sectionIndex];

                visualizations = visualizations.concat(
                    section.visualizationsIds
                );
            }

            indicator.childrens = visualizations;
            allVisualizations.push(indicator);
        }

        return this._getVisualizationsInfo(allVisualizations);
    }

    _getVisualizationsInfo(visualizations) {
        return visualizations.map((indicator) => {
            const childrens = indicator.childrens.map((children) => {
                const vizId = this.parseDashboardVisualization({
                    visualizationId: children,
                    companyData: this.companyData
                });

                const visualization = this.findOneCollection({
                    _id: { $eq: vizId }
                });

                if (visualization) visualization.notifications = 0;
                return visualization;
            });

            _.remove(childrens, (children) => children === null);

            indicator.childrens = childrens;
            return indicator;
        });
    }

    /**
     * @public
     * Salva coleções de visualização por source
     * @param {String} companyId
     * @param {String} source
     * @param {Array} visualizations
     * @returns {Boolean}
     */
    populateBySource({ companyId, source, visualizations } = {}) {
        this.deleteMany({
            companyId: { $eq: companyId },
            sources: { $eq: source }
        });

        this.createMany(visualizations);

        return true;
    }

    async getByIds(vizIds) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlVisualization}/get-by-ids`,
            {
                ids: [].concat(vizIds)
            }
        );

        return response.data || [];
    }

    async getByCompanyIdSources({ companyId, sources, options }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlVisualization}/get-by-companyid-sources`,
                { companyId, sources: [].concat(sources), options }
            );

            return response.list || [];
        } catch (error) {
            throw new Error(error.message);
        }
    }

    createMany(data = []) {
        this._before();

        const total = data.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            const document = data[i];

            if (document.updatedAt)
                document.updatedAt = new Date(document.updatedAt).getTime();

            if (document.createdAt)
                document.createdAt = new Date(document.createdAt).getTime();

            this.create(document);
        }

        return true;
    }

    modelerVisualization({
        props,
        companyId,
        accountingId,
        user,
        source,
        needLegend = false
    }) {
        const unitsLabel = {
            currency: {
                enabled: true,
                formatter: "currency"
            },
            percentage: {
                enabled: true,
                format: "{value:.0f}%"
            },
            default: {
                enabled: true,
                format: "{value}"
            }
        };

        const allUnits = props.indicators.map((i) => i.unit);
        const indicatorsUnits = _.uniq(allUnits);

        const chartCategories = {
            area: {
                category: "area",
                chart: {
                    reflow: true,
                    type: "area"
                },
                series: props.indicators.map((i, idx) => {
                    return {
                        type: "area",
                        _id: i._id,
                        name_v: i.name,
                        color: i.color,
                        yAxis: indicatorsUnits.length > 1 ? idx : 0
                    };
                }),
                legend: {
                    enabled: needLegend
                },
                yAxis: props.indicators.map((i, idx) => {
                    return {
                        title: {
                            text: ""
                        },
                        plotLines: [
                            {
                                width: 1.0,
                                value: 0.0,
                                zIndex: 6.0
                            }
                        ],
                        labels: unitsLabel[i.unit] || unitsLabel["default"],
                        opposite: idx ? true : false
                    };
                }),
                plotOptions: {
                    area: {
                        pointPadding: 0.2,

                        allowPointSelect: true,
                        cursor: "pointer",
                        dataLabels: {
                            enabled: false
                        },
                        marker: {
                            enabled: false,
                            symbol: "circle",
                            radius: 2.0,
                            states: {
                                hover: {
                                    enabled: true
                                }
                            }
                        }
                    }
                }
            },
            bars: {
                category: "column",
                chart: {
                    reflow: true,
                    type: "column"
                },
                legend: {
                    enabled: needLegend
                },
                plotOptions: {
                    area: {
                        allowPointSelect: true,

                        cursor: "pointer",
                        dataLabels: {
                            enabled: false
                        },
                        marker: {
                            enabled: false,
                            radius: 2,
                            states: {
                                hover: {
                                    enabled: true
                                }
                            },
                            symbol: "circle"
                        },
                        pointPadding: 0.2
                    },
                    series: {}
                },
                series: props.indicators.map((i, idx) => {
                    return {
                        _id: i._id,
                        color: i.color,
                        nameDoc: i.name,
                        type: "column",
                        yAxis: indicatorsUnits.length > 1 ? idx : 0
                    };
                }),
                yAxis: props.indicators.map((i, idx) => {
                    return {
                        plotLines: [
                            {
                                value: 0,
                                width: 1,
                                zIndex: 6
                            }
                        ],
                        labels: unitsLabel[i.unit] || unitsLabel["default"],
                        title: {
                            text: ""
                        },
                        opposite: idx ? true : false
                    };
                })
            },
            combinations: {
                category: "combinations",
                chart: {
                    reflow: true
                },
                legend: {
                    enabled: needLegend
                },
                series: props.indicators.map((i, idx) => {
                    const types = {
                        line: {
                            _id: i._id,
                            type: "line",
                            color: i.color,
                            zIndex: 1.0,
                            marker: {
                                lineWidth: 2.0,
                                lineColor: "rgb(249,192, 44)",
                                fillColor: "white"
                            },
                            yAxis: indicatorsUnits.length > 1 ? idx : 0
                        },
                        column: {
                            type: "column",
                            _id: i._id,
                            stack: "value",
                            color: i.color,
                            yAxis: indicatorsUnits.length > 1 ? idx : 0
                        }
                    };

                    return types[i.type];
                }),
                yAxis: props.indicators.map((i, idx) => {
                    const units = {
                        percentage: {
                            labels: {
                                enabled: true,
                                format: "{value:.0f}%"
                            },
                            title: {
                                text: ""
                            },
                            plotBands: [
                                {
                                    color: "#000",
                                    zIndex: 6.0
                                }
                            ],
                            opposite: indicatorsUnits.length > 1 ? true : false
                        },
                        currency: {
                            labels: {
                                enabled: true,
                                formatter: "currency"
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    width: 1.0,
                                    value: 0.0,
                                    zIndex: 6.0
                                }
                            ]
                        },
                        default: {
                            labels: {
                                enabled: true,
                                format: "{value}"
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    width: 1.0,
                                    value: 0.0,
                                    zIndex: 6.0
                                }
                            ]
                        }
                    };

                    const yAxi = units[i.unit] || units["default"];

                    if (yAxi && indicatorsUnits.length === 1 && idx)
                        yAxi.labels.enabled = false;

                    return yAxi;
                }),
                plotOptions: {
                    column: {}
                }
            },
            donut: {
                category: "donut",
                chart: {
                    animation: true,
                    reflow: true,
                    type: "pie"
                },
                plotOptions: {
                    pie: {
                        dataLabels: {
                            enabled: false
                        },
                        size: "90%",
                        slicedOffset: 0
                    },
                    series: {
                        enableMouseTracking: false,
                        states: {
                            hover: {
                                halo: {
                                    size: 1
                                }
                            }
                        }
                    }
                },
                series:
                    props.indicators.length > 1
                        ? props.indicators
                              .filter((i) => i.type === "donut")
                              .map((i) => {
                                  return {
                                      _id: i._id,
                                      color: i.color,
                                      data: [
                                          {
                                              color: "rgb(249,192, 44)"
                                          },
                                          {
                                              color: "#e8ebeb"
                                          }
                                      ],
                                      dataLabels: {
                                          enabled: false
                                      },
                                      innerSize: "92%",
                                      showInLegend: false
                                  };
                              })
                        : props.indicators.map((i) => {
                              return {
                                  _id: i._id,
                                  color: i.color,
                                  data: [
                                      {
                                          color: "rgb(249,192, 44)"
                                      },
                                      {
                                          color: "#e8ebeb"
                                      }
                                  ],
                                  dataLabels: {
                                      enabled: false
                                  },
                                  innerSize: "92%",
                                  showInLegend: false
                              };
                          }),
                title: {
                    align: "center",
                    style: {
                        color: "rgb(249,192, 44)",
                        fontFamily: "Open Sans",
                        fontSize: "30px",
                        fontWeight: "bold"
                    },
                    verticalAlign: "middle",
                    y: 30
                }
            },
            line: {
                category: "line",
                chart: {
                    type: "line",
                    reflow: true
                },
                series: props.indicators.map((i, idx) => {
                    return {
                        type: "line",
                        _id: i._id,
                        color: i.color,
                        yAxis: indicatorsUnits.length > 1 ? idx : 0
                    };
                }),
                legend: {
                    enabled: needLegend
                },
                yAxis: props.indicators.map((i, idx) => {
                    return {
                        title: {
                            enabled: false
                        },
                        plotLines: [
                            {
                                width: 1,
                                value: 0,
                                zIndex: 6
                            }
                        ],
                        opposite: idx ? true : false,
                        labels: unitsLabel[i.unit] || unitsLabel["default"]
                    };
                })
            },
            column: {
                category: "column",
                series: props.indicators.map((i, idx) => {
                    return {
                        _id: i._id,
                        color: i.color,
                        type: "column",
                        stack: "value",
                        yAxis: indicatorsUnits.length > 1 ? idx : 0
                    };
                }),
                labels: {
                    items: [
                        {
                            style: {
                                left: "50px",
                                top: "18px",
                                color: "rgb(48, 206, 212)"
                            }
                        }
                    ]
                },
                legend: {
                    enabled: needLegend
                },
                yAxis: props.indicators.map((i, idx) => {
                    return {
                        opposite: idx ? true : false,
                        labels: unitsLabel[i.unit] || unitsLabel["default"],
                        title: {
                            text: ""
                        },
                        plotLines: [
                            {
                                color: "#000",
                                width: 1,
                                value: 0
                            }
                        ]
                    };
                }),
                plotOptions: {
                    column: {
                        stacking: "normal",
                        cursor: "pointer"
                    },
                    series: {}
                }
            },
            pie: {
                category: "pie",
                chart: {
                    animation: {
                        duration: 1000
                    },
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie"
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true
                    }
                },
                series: props.indicators.map((i) => {
                    return {
                        _id: i._id,
                        color: i.color
                    };
                }),
                legend: {
                    align: "right",
                    verticalAlign: "middle",
                    layout: "vertical",
                    labelFormat: "{name} ({percentage:.1f}%)"
                }
            },
            METRIC_KPI: {
                series: props.indicators.map((i, idx) => {
                    return {
                        _id: i._id,
                        color: i.color
                    };
                }),
                component: {
                    name: "METRIC_KPI",
                    configs: {
                        series: props.indicators.map((i, idx) => {
                            return {
                                _id: i._id,
                                color: i.color
                            };
                        })
                    }
                }
            }
        };

        const visualization = {
            companyId,
            accountingId,
            sources: source,
            name: props.name,
            name_nd: _.deburr(props.name).toUpperCase(),
            metadata: {
                customized: {
                    userId: user._id,
                    t: new Date()
                }
            },
            description: props.description,
            chart: chartCategories[props.chart],
            createdAt: new Date()
        };

        if (props.chart === "METRIC_KPI") {
            visualization.metadata.hideIndicatorValues = true;
            visualization.component = chartCategories[props.chart].component;
            delete visualization.chart.component;
        }

        if (props.chart === "donut") {
            visualization.series =
                props.indicators.length > 1
                    ? props.indicators
                          .filter((i) => i.type === "donut")
                          .map((i) => i._id)
                    : props.indicators.map((i) => i._id);
        } else {
            visualization.series = props.indicators.map((i) => i._id);
        }

        return visualization;
    }

    async saveCustomVisualization({
        props,
        companyId,
        accountingId,
        user,
        source,
        visualizationId,
        needLegend
    }) {
        const visualization = this.modelerVisualization({
            props,
            companyId,
            accountingId,
            user,
            source,
            needLegend
        });

        if (visualizationId)
            await this.updateOne(visualizationId, visualization);
        else return await this.insertOne(visualization);
    }

    async updateConfigSeries({ _id, series }) {
        if (!_id) return false;

        if (!series) return false;

        const response = await this.save({
            _id,
            component: {
                configs: {
                    series
                }
            }
        });

        const modify = this.modify(
            { _id: { $eq: _id } },
            { $set: { "component.configs.series": series } }
        );

        return response;
    }
}
